import { useSelector, useDispatch } from 'react-redux'
import {
    SidebarWrap,
    Menu,
    Item,
    UserLink,
    SaveIc,
    Newstotal,
    CommentIc,
    SettingIc,
    CommentTotal
} from './sidebarElements'
import { useLocation } from 'react-router-dom'
import UserInfo from '../userInfo'
import { useEffect } from 'react'
import { getUserComments } from '../../../store/reducer/userSlice'


const Sidebar = () => {
    const { user, comments } = useSelector(state => state.user)
    const location = useLocation()
    const dispatch = useDispatch()
    
    useEffect(() => {
        ;(async () => {
            await dispatch(getUserComments({ _page: 1 }))
        })()
    }, [dispatch])

    return (
        <SidebarWrap>
            <UserInfo />
            <Menu>
                <Item>
                    <UserLink className={location.pathname === '/me/news'?'active':''} to="/me/news" title="Tin đã lưu">
                        <SaveIc />
                        Tin đã lưu
                        <Newstotal>{user.newsSaved?.length}</Newstotal>
                    </UserLink>
                </Item>
                <Item>
                    <UserLink className={location.pathname === '/me/comments'?'active':''} to="/me/comments" title="Bình luận">
                        <CommentIc />
                        Bình luận
                        <CommentTotal>{comments?.totalRows?.total || 0}</CommentTotal>
                    </UserLink>
                </Item>
                <Item>
                    <UserLink className={location.pathname === '/me/account'?'active':''} to="/me/account" title="Cài đặt tài khoản">
                        <SettingIc />
                        Cài đặt tài khoản
                    </UserLink>
                </Item>
            </Menu>
        </SidebarWrap>
    )
}

export default Sidebar
